import styles from "./TextArea.module.scss";
import { Controller } from "react-hook-form";
import type {
  Control,
  FieldValues,
  RegisterOptions,
  UseFormRegisterReturn,
} from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";

export interface TextAreaProps<TFieldValues extends FieldValues = FieldValues> {
  control?: Control<TFieldValues>;
  register?: (name: string, options?: RegisterOptions<TFieldValues>) => UseFormRegisterReturn;
  validations?: RegisterOptions<TFieldValues>;
  name: string;
  placeholder?: string;
  type?: string;
  className?: string;
  [key: string]: unknown;
}

const TextArea = <TFieldValues extends FieldValues = FieldValues>({
  control,
  register,
  validations,
  name,
  placeholder,
  type: _type,
  className,
  ...rest
}: TextAreaProps<TFieldValues>) => {
  const renderTextArea = (field: Partial<UseFormRegisterReturn> = {}) => (
    <textarea
      {...field}
      {...rest}
      id={name}
      className={combineClasses(styles.inputField, className)}
      placeholder={placeholder}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        {...(validations ? { rules: validations } : {})}
        name={name as never}
        render={({ field }) => renderTextArea(field as unknown as Partial<UseFormRegisterReturn>)}
      />
    );
  } else {
    const field = register ? register(name, validations) : {};
    return renderTextArea(field);
  }
};

const TextAreaWithLabelAndError = withLabelAndError(TextArea);

export default TextAreaWithLabelAndError;
export { TextArea };
